import React from 'react';
import PingStatus from './PingStatus';

export default function ZUpload() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:829/ping"
      pingAuth={{ username: 'CloudShared', password: 'CloudShared@1163' }}
      restartKey="upload"
      interval={5000}
    />
  );
}
